module.exports = __webpack_public_path__ + "static/media/image1.74d0a671.png";